import { call, put, takeEvery } from 'redux-saga/effects';
import { getAdminConfigList } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const responce = yield call(getAdminConfigList, action.payload);
  if (responce.isOk) {
    return yield put(requestSuccess({ data: responce.data, type: action.payload }));
  }
  return yield put(requestFailure(responce.error));
}

export default function* adminConfigSaga() {
  yield takeEvery(actionTypes.REQUEST_START, getData);
}
